/**
 * Token验证工具
 */

/**
 * 解析JWT token获取过期时间
 * @param token JWT token字符串
 * @returns 过期时间戳（毫秒）或null
 */
export function getTokenExpiration(token: string): number | null {
  try {
    // JWT格式: header.payload.signature
    const parts = token.split('.')
    if (parts.length !== 3) {
      return null
    }

    // 解码payload部分
    const payload = JSON.parse(atob(parts[1]))

    // exp字段是秒级时间戳，需要转换为毫秒
    if (payload.exp) {
      return payload.exp * 1000
    }

    return null
  } catch (error) {
    console.error('解析token失败:', error)
    return null
  }
}

/**
 * 检查token是否过期
 * @param token JWT token字符串
 * @returns true表示已过期，false表示未过期
 */
export function isTokenExpired(token: string | null): boolean {
  if (!token) {
    return true
  }

  const expiration = getTokenExpiration(token)
  if (!expiration) {
    return true
  }

  // 当前时间戳
  const now = Date.now()

  // 如果过期时间小于当前时间，说明已过期
  return expiration < now
}

/**
 * 清除认证信息
 */
export function clearAuthData(): void {
  localStorage.removeItem('token')
  localStorage.removeItem('role')
}
